    import React, { useEffect, useState } from "react";
    import Api from "../../Services/Api";
    import {
    Container,
    Typography,
    CircularProgress,
    Paper,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Grid, CardContent, Card, TableContainer
} from "@mui/material";

    import MainLayout from "../MainLoyout/MainLayout";
    import dayjs from 'dayjs';
    import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
    import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
    import { DatePicker } from '@mui/x-date-pickers/DatePicker';

    const Mediabuying = () => {
        const [data, setData] = useState({
            combinedTotals: {},
            tonicTotals: {},
            system1Totals: {},
            campaignData: {}
        });
        const [loading, setLoading] = useState(false);
        const [selectedDate, setSelectedDate] = useState(dayjs());
        const [error, setError] = useState(null);



        useEffect(() => {
            fetchData(new Date());  // Fetch data for today's date when component mounts
        }, []);

        const handleDateChange = (date) => {
            setSelectedDate(date);
            fetchData(date);
        };

        const fetchData = (date) => {
            setLoading(true);
            const dayjsDate = dayjs(date);  // Convert to dayjs object
            const formattedDate = `${dayjsDate.year()}-${String(dayjsDate.month() + 1).padStart(2, '0')}-${String(dayjsDate.date()).padStart(2, '0')}`;
            Api.mediabuyingData({ day: formattedDate })
                .then(response => {
                    setData(response);
                    setLoading(false);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setError('Something went wrong. Please try again.');
                    setLoading(false);
                });
        };

        const {
            combinedTotals = {},
            tonicTotals = {},
            system1Totals = {},
            campaignData = {},
        } = data;


        if (error) {
            return (
                <MainLayout>
                    <Container maxWidth="xl">
                        <Typography variant="h6" color="error">
                            {error}
                        </Typography>
                    </Container>
                </MainLayout>
            );
        }









        if (loading) {
            return (
                <MainLayout>
                    <Container maxWidth="xl" sx={{ mt: 4, mb: 4, display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                    </Container>
                </MainLayout>
            );
        }

        return (
            <MainLayout>
                <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>

                    <Grid container spacing={3} sx={{ mb: 4 }}>
                        <Grid item xs={6} md={2}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h5">
                                        Spent
                                    </Typography>
                                    <Typography variant="h6">
                                        ${parseFloat(data.combined_totals?.spent || 0).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6} md={2}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h5">
                                        Revenue
                                    </Typography>
                                    <Typography variant="h6">
                                        ${parseFloat(data.combined_totals?.total_revenue || 0).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6} md={2}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h5">
                                        Profit
                                    </Typography>
                                    <Typography variant="h6">
                                        ${parseFloat(data.combined_totals?.profit || 0).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6} md={2}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h5">
                                        N.Z Profit
                                    </Typography>
                                    <Typography variant="h6">
                                        ${parseFloat(data.combined_totals?.nz_profit || 0).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6} md={2}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h5">
                                        ROI
                                    </Typography>
                                    <Typography variant="h6">
                                        {data.combined_totals?.roi}%
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6} md={2}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h5">
                                        N.Z ROI
                                    </Typography>
                                    <Typography variant="h6">
                                        {data.combined_totals?.nz_roi}%
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6} md={2}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h5">
                                        ROAS
                                    </Typography>
                                    <Typography variant="h6">
                                        {data.combined_totals?.roas}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Paper elevation={3} sx={{ p: 3 }}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item>
                                        <DatePicker
                                            label="Select Date"
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => fetchData(selectedDate)}
                                        >
                                            Refresh
                                        </Button>
                                    </Grid>
                                </Grid>

                            <TableContainer component={Paper} sx={{ overflowX: 'auto', mt:2 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Metric</TableCell>
                                        <TableCell>Tonic Totals</TableCell>
                                        <TableCell>System1 Totals</TableCell>
                                        <TableCell>Combined Totals</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Revenue</TableCell>
                                        <TableCell>${parseFloat(data.totals_tonic?.total_revenue || 0).toFixed(2)}</TableCell>
                                        <TableCell>${parseFloat(data.totals_system1?.total_revenue || 0).toFixed(2)}</TableCell>
                                        <TableCell>${parseFloat(data.combined_totals?.total_revenue || 0).toFixed(2)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>ZMB Revenue</TableCell>
                                        <TableCell>${parseFloat(data.totals_tonic?.zmb_revenue || 0).toFixed(2)} ({parseFloat(data.totals_tonic?.zmb_percent_revenue || 0).toFixed(2)}%)</TableCell>
                                        <TableCell>${parseFloat(data.totals_system1?.zmb_revenue || 0).toFixed(2)} ({parseFloat(data.totals_system1?.zmb_percent_revenue || 0).toFixed(2)}%)</TableCell>
                                        <TableCell>${parseFloat(data.combined_totals?.zmb_revenue || 0).toFixed(2)} ({parseFloat(data.combined_totals?.zmb_percent_revenue || 0).toFixed(2)}%)</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Clicks</TableCell>
                                        <TableCell>{data.totals_tonic?.total_clicks}</TableCell>
                                        <TableCell>{data.totals_system1?.total_clicks}</TableCell>
                                        <TableCell>{data.combined_totals?.total_clicks}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>ZMB Clicks</TableCell>
                                        <TableCell>{data.totals_tonic?.zmb_clicks} ({parseFloat(data.totals_tonic?.zmb_percent_clicks || 0).toFixed(2)}%)</TableCell>
                                        <TableCell>{data.totals_system1?.zmb_clicks} ({parseFloat(data.totals_system1?.zmb_percent_clicks || 0).toFixed(2)}%)</TableCell>
                                        <TableCell>{data.combined_totals?.zmb_clicks} ({parseFloat(data.combined_totals?.zmb_percent_clicks || 0).toFixed(2)}%)</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>EPC</TableCell>
                                        <TableCell>${parseFloat(data.totals_tonic?.epc || 0).toFixed(2)}</TableCell>
                                        <TableCell>${parseFloat(data.totals_system1?.epc || 0).toFixed(2)}</TableCell>
                                        <TableCell>${parseFloat(data.combined_totals?.epc || 0).toFixed(2)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                            </TableContainer>




                            <Typography variant="h6" sx={{ mt: 4 }}>
                                Taboola Campaigns
                            </Typography>
                            {renderCampaignTable(data.campaign_data)}

                        </Paper>
                    </LocalizationProvider>
                </Container>
            </MainLayout>
        );

        function renderCampaignTable(campaignsData) {
            if (!campaignsData) {
                return <Typography>No Campaign Data</Typography>;
            }

            const campaignKeys = Object.keys(campaignsData);

            // Initialize totals object
            const totals = {
                total_revenue: 0,
                total_revenue_mb: 0,
                spent: 0,
                clicks: 0,
                conversions_mb: 0,
                epc_system1: 0,
                epc_tonic: 0
            };

            // Calculate the totals for each column
            campaignKeys.forEach((key) => {
                totals.total_revenue += parseFloat(campaignsData[key].total_revenue || 0);
                totals.total_revenue_mb += parseFloat(campaignsData[key].revenue_mb || 0); // Assuming total_revenue_mb is the correct variable for MB revenue
                totals.spent += parseFloat(campaignsData[key].spent || 0);
                totals.clicks += parseInt(campaignsData[key].clicks || 0);
                totals.conversions_mb += parseInt(campaignsData[key].conversions_mb || 0);
                totals.epc_system1 += parseFloat(campaignsData[key].epc_system1 || 0);
                totals.epc_tonic += parseFloat(campaignsData[key].epc_tonic || 0);
            });

            // Calculate total ROI, ROAS, CR, and average EPC
            totals.roi = totals.spent ? ((totals.total_revenue - totals.spent) / totals.spent) * 100 : 0;
            totals.roi_mb = totals.spent ? ((totals.total_revenue_mb - totals.spent) / totals.spent) * 100 : 0; // Calculating ROI MB
            totals.roas = totals.spent ? totals.total_revenue / totals.spent : 0;
            totals.roas_mb = totals.spent ? totals.total_revenue_mb / totals.spent : 0;
            totals.cr = totals.clicks ? (totals.conversions_mb / totals.clicks) * 100 : 0; // Calculating total CR
            totals.epc_system1 = campaignKeys.length ? totals.epc_system1 / campaignKeys.length : 0;
            totals.epc_tonic = campaignKeys.length ? totals.epc_tonic / campaignKeys.length : 0;



            return (
                <TableContainer component={Paper} sx={{ overflowX: 'auto', mt:2 }}>

                <Table >
                    <TableHead>
                        <TableRow>
                            <TableCell> </TableCell>
                            <TableCell>Campaign Name</TableCell>
                            <TableCell>Spent</TableCell>
                            <TableCell>Revenue</TableCell>
                            <TableCell>ROI</TableCell>
                            <TableCell>ROI MB</TableCell>
                            <TableCell>ROAS</TableCell>
                            <TableCell>ROAS MB</TableCell>
                            <TableCell>Clicks</TableCell>
                            <TableCell>Conversions MB</TableCell>
                            <TableCell>CR</TableCell>
                            <TableCell>EPC SYSTEM1</TableCell>
                            <TableCell>EPC TONIC</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {campaignKeys.map((key) => (
                            <TableRow
                                key={key}
                            >
                                <TableCell
                                    sx={{
                                        backgroundColor: campaignsData[key].roi < 0 ? 'rgba(255,0,0,0.3)' : 'inherit',
                                        width: '5px', // Adjust as necessary
                                    }}
                                />
                                <TableCell>{campaignsData[key].campaign_name}</TableCell>
                                <TableCell>
                                    ${parseFloat(campaignsData[key].spent || 0).toFixed(2)}
                                </TableCell>
                                <TableCell>
                                    ${parseFloat(campaignsData[key].total_revenue || 0).toFixed(2)}
                                </TableCell>

                                <TableCell>{campaignsData[key].roi}%</TableCell>
                                <TableCell>{campaignsData[key].roi_mb}%</TableCell>
                                <TableCell>{campaignsData[key].roas}</TableCell>
                                <TableCell>{campaignsData[key].roas_mb}</TableCell>
                                <TableCell>{campaignsData[key].clicks}</TableCell>
                                <TableCell>{campaignsData[key].conversions_mb}</TableCell>
                                <TableCell>{campaignsData[key].cr}%</TableCell>
                                <TableCell>
                                    ${parseFloat(campaignsData[key].epc_system1 || 0).toFixed(2)}
                                </TableCell>
                                <TableCell>
                                    ${parseFloat(campaignsData[key].epc_tonic || 0).toFixed(2)}
                                </TableCell>
                            </TableRow>
                        ))}
                        {/* Adding a row for the totals */}
                        <TableRow>
                            <TableCell>-</TableCell>
                            <TableCell>Totals</TableCell>
                            <TableCell>${totals.spent.toFixed(2)}</TableCell>
                            <TableCell>${totals.total_revenue.toFixed(2)}</TableCell>
                            <TableCell>{totals.roi.toFixed(2)}%</TableCell>
                            <TableCell>{totals.roi_mb.toFixed(2)}%</TableCell>
                            <TableCell>{totals.roas.toFixed(2)}</TableCell>
                            <TableCell>{totals.roas_mb.toFixed(2)}</TableCell>
                            <TableCell>{totals.clicks}</TableCell>
                            <TableCell>{totals.conversions_mb}</TableCell>
                            <TableCell>{totals.cr.toFixed(2)}%</TableCell>
                            <TableCell>${totals.epc_system1.toFixed(2)}</TableCell>
                            <TableCell>${totals.epc_tonic.toFixed(2)}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                </TableContainer>
            );
        }



    };

    export default Mediabuying;
